import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { edcUrls } from "../../URL/ApplicationUrls";
import { Edc } from "../Edc";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { MdmApiError } from "../../Errors/MdmApiError";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useUpdateEdc = (edcId: number | string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (edc: Edc) => {
      return axios.put<Edc>(edcUrls.base.apiUrl, edc);
    },
    onSuccess: async (response: AxiosResponse<Edc>) => {
      const edc = response.data;
      await queryClient.invalidateQueries(namedQueryKeyWithId("edcs", edc.Id));
      toast.success(`Updating the EDC with the Id ${edc.Id} was successful`);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
